<template>
    <div class="component-address-list">
        <van-popup v-model="show_address" round position="bottom" class='ldm-popup' closeable>
            <div class="popup-title">请选择收货地址</div>
            <div class="popup-select-area-body">
                <van-empty description="请添加地址" v-if="address_list.length==0" />
                <div class="area-card" v-for='address in address_list' @click='select_address(address)' v-else>
                    <div class="selector">
                        <van-icon name="checked" v-if='address_select_id==address.id' />
                        <van-icon name="passed" v-else />

                    </div>
                    <div class="left">
                        <div class="title">
                            {{address.name}} {{address.tel}}
                            <van-tag round type="danger" v-if='address.isDefault'>默认</van-tag>
                        </div>
                        <div class="detail">
                            {{address.city}}{{address.country}}{{address.addressDetail}}
                        </div>
                    </div>
                    <div class="right">
                        <van-icon name="edit" @click='edit_address' />
                    </div>

                </div>
            </div>
            <div class="btn-group">
                <div class="btn add" @click='add_address'>添加地址</div>
                <div class="btn pay" v-if='address_select_id!=""' @click='callpay'>去支付</div>
                <div class="btn disable" v-else>去支付</div>
            </div>

        </van-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show_address: false,
                address_list: [],
                address_select_id: "",

            }
        },
        mounted() {
            let self = this


        },
        methods: {
            edit_address(e) {
                let self = this
                console.log('edit', e)
                self.show_edit = true
            },
            select_address(address) {
                let self = this
                self.address_select_id = address.id
            },
            callpay(){
                let self = this
                self.$emit('success',self.address_select_id)
            },
            add_address() { 
                let self = this
                self.$router.push({
                    name: "AddAddress"
                })
            },
            open() {
                let self = this
                self.$http.get('/v1/get_address_list').then(function(re) {
                    self.address_list = re.body.address_list
                    self.show_address = true
                })
            }
        }
    }

</script>
<style lang='scss'>
    .component-address-list {}

</style>
